enum Claims {
  MenuConfiguracoes = 1,
  LogAcoes = 2,
  ImportarCandidatos = 3,
  BloquearMultiplasCelulas = 4,
  AprovarMultiplasCelulas = 5,
  LiberarMultiplasCelulas = 6,
  BloquearHorario = 7,
  CancelarHorario = 8,
  ReservarHorario = 9,
  AlterarHorario = 10,
  AprovarHorario = 11,
  NoShowHorario = 12,
  Chat = 13,
  Macro = 14,
  Alerta = 15,
  VerDetalhes = 16,
  LiberarHorario = 17,
  Checklist = 18,
  VerDetalhesTodasTransportadoras = 19,
  VerTodosCandidatos = 20,
  CriarEditarArmazem = 21,
  ListaChegadas = 22,
  ReservarAprovarHorario = 56,
  EditarStatusTransportadorasBiomassa = 58,
  VisualizarStatusTransportadorasBiomassa = 59,
  EditarDadosBasicosAgendamentoBiomassa = 61,
  EditarDadosCompletosAgendamentoBiomassa = 62,
  EmitirMacrosDocas = 63,
  VisualizarMacrosDocas = 64,
}

export default Claims
